<template>
  <main id="app">
    <router-view :key="$route.fullPath" />
    <template>
      <cookies-view
        :open-window="openWindow"
        @closeDetails="closeDetailsWindow"
      />
    </template>
    <footer-cookies-view
      :class="{'footer-cookies--open' : openCookiesFooter}"
      @openDetails="openDetailsWindow"
      @closeFooter="closeFooter"
    />
  </main>
</template>

<script>
import objectFitImages from 'object-fit-images';
import * as cookie from '@/utils/cookies';

export default {
  components: {
    FooterCookiesView: () => import('@/components/footer/footer-cookies-view'),
    CookiesView: () => import('@/components/cookies/cookies-view')
  },

  data() {
    return {
      openCookiesFooter: false,
      openWindow: false,
      cookie: cookie
    };
  },

  watch: {
    $route(to, from) {
      if (from.name === 'privacy_policy') {
        this.checkCookie();
        this.openCookiesFooter = true;
      }
    }
  },

  mounted() {
    objectFitImages();
    this.checkCookie();
    this.cookie.setGaCookies(true);
  },
  methods: {
    openDetailsWindow() {
      this.openWindow = true;
      this.openCookiesFooter = false;
      document.documentElement.style.overflow = 'hidden';
    },

    closeFooter() {
      this.openCookiesFooter = false;
    },

    closeDetailsWindow() {
      this.openWindow = false;
      document.documentElement.style.overflow = 'scroll';
    },

    checkCookie() {
      if (this.$router.currentRoute.name !== 'privacy_policy') {
        let controlFooter = this.cookie.getCookie('cookies-bliss');
        if (!controlFooter) {
          this.openCookiesFooter = true;
        } else {
          this.openCookiesFooter = false;
          this.openWindow = false;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// App.vue